import { UploadFlowDialogValues } from '../components/UploadFlowDialog';

export namespace UploadFlowActionsTypes {
  export const START = 'UPLOAD_FLOW_START';
}

export interface UploadFlowStartAction {
  readonly type: typeof UploadFlowActionsTypes.START;
  readonly data: UploadFlowDialogValues;
  readonly overwrite: boolean;
}

export function requestUploadFlowAction(args: Omit<UploadFlowStartAction, 'type'>): UploadFlowStartAction {
  return {
    type: UploadFlowActionsTypes.START,
    ...args
  };
}
